<strong class="text-primary align-self-center room-number"> {{ roomNumber$ | async }} </strong>